import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/shape-20.png'
import _imports_1 from '@/assets/images/shape-21.png'


const _hoisted_1 = { class: "page-banner-area style-two bg-secondary overflow-hidden" }
const _hoisted_2 = { class: "container mw-1720" }
const _hoisted_3 = { class: "page-banner-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 list-unstyled bredcrounbs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" HOME ", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("li", null, [
            _createElementVNode("span", null, "PAY BILL")
          ], -1))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Pay Bill", -1))
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape-21 shape",
      alt: "shape"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape-22 shape",
      alt: "shape"
    }, null, -1))
  ]))
}